import React from "react";
import ApprovalComponent from "../../../../../Components/Utils/approvalComponent";
import { GetMultiNotUseRole } from "../../../../../Components/Utils/roles";
import PDFViewWithAPI from "../../../../../Components/Utils/PDFViewWithAPI";
import ExcelViewWithAPI from "../../../../../Components/Utils/ExcelViewWithAPI";
import CommonComments from "../../../../../Components/Utils/commonComments";

function TempTrCom({ label = "", value = "" }) {
  return (
    <tr className="w-full">
      <td className="w-[70px]">
        <p className="py-2 text-xs font-medium text-[#111537]">{label}</p>
      </td>
      <td className="w-[10px]">:</td>
      <td className="flex-1">
        <p className="py-2 text-xs text-[#606279] truncate text-wrap">
          {value}
        </p>
      </td>
    </tr>
  );
}

const PrSidebar = ({
  prViewId,
  data,
  setData,
  relatedDoc = [],
  relatedExcelDoc = [],
}) => {
  const getUrl = "/PR/get-status";
  const putUrl = "/PR/edit-status";
  const statusUrl = "/PR/all-status";

  return (
    <div className="w-full lg:w-[30%] bg-white rounded-xl shadow-xs border border-slate-200/80 py-3 px-2 flex flex-col">
      <div className="h-full overflow-y-auto space-y-4">
        {/* Approval Component */}
        <ApprovalComponent
          id={prViewId}
          getUrl={getUrl}
          putUrl={putUrl}
          statusUrl={statusUrl}
          refSetData={setData}
          data={data}
          type="PR"
          preUrlName="PR"
        />

        {/* Customer Detail Card */}
        {data?.customerId &&
          GetMultiNotUseRole(["procurement", "procurement supervisor"]) && (
            <div className="w-full grid border rounded-lg bg-white overflow-hidden">
              <div className="bg-baseColor-primary p-2">
                <p className="text-xs text-white font-medium">Customer Detail</p>
              </div>
              <div className="w-full px-2">
                <table className="w-full border-collapse text-left">
                  <tbody>
                    {data.customerName && (
                      <TempTrCom
                        label="Customer"
                        value={data?.customerName || ""}
                      />
                    )}
                    <TempTrCom
                      label="Reference"
                      value={data?.customerRfqRef || ""}
                    />
                    {data?.customerCat && (
                      <TempTrCom
                        label="Category"
                        value={
                          data?.customerCat?.charAt(0).toUpperCase() +
                          data?.customerCat?.slice(1) || "-"
                        }
                      />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

        {/* Related Documents Card */}
        {data?.customerId && (
          <div className="w-full grid border rounded-lg bg-white overflow-hidden">
            <p className="text-xs text-white font-medium bg-baseColor-primary p-2">
              Documents
            </p>
            <div className="w-full flex flex-wrap overflow-y-auto h-20 p-2 gap-1">
              {relatedDoc.length > 0 &&
                relatedDoc.map((doc, index) => (
                  <PDFViewWithAPI item={doc} key={`pdf-${index}`} />
                ))}
              {relatedExcelDoc.length > 0 &&
                relatedExcelDoc.map((doc, index) => (
                  <ExcelViewWithAPI item={doc} key={`excel-${index}`} />
                ))}
              {relatedDoc.length === 0 && relatedExcelDoc.length === 0 && (
                <p className="text-xs text-[#9DA3AA] p-1">No documents available</p>
              )}
            </div>
          </div>
        )}

        {/* Comments Section */}
        <div className="w-full h-auto flex border rounded-lg overflow-hidden bg-white">
          <CommonComments
            visible={true}
            title="Comments"
            mainId={prViewId}
            addurl="/pr-comments/new-comment"
            geturl={`/pr-comments/by-PR/${prViewId}`}
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(PrSidebar);
